import axios from 'axios';

import getHeaderToken from 'functions/getHeaderToken';

import{ Logger } from 'aws-amplify';
const logger = new Logger('CorporationCollaboration-log');

const postCorporationCollaboration = async (url, corporationOfficeNumber, facilityOfficeNumber, setSelectedFacility, collaborations, setCollaborations) => {

    const postData = {
        corporation_office_number: corporationOfficeNumber,
        facility_office_number: facilityOfficeNumber
    };
    const config = await getHeaderToken();
    const error_message = '連携施設の追加に失敗しました。\n\nステータスコード：'

    axios
        .post(url, postData, config)
        .then((res) => {
            if (res.status === 201) {
                let updatedCollaborations = collaborations.concat();
                updatedCollaborations.push({
                    facility_office_number: facilityOfficeNumber
                });
                setCollaborations(updatedCollaborations);
                setSelectedFacility('');
            } else {
                logger.error(res);
                window.alert(error_message + res.status);
            }
        })
        .catch((e) => {
            logger.error(e);
            window.alert(error_message + e.response.status);
        });

};

export default postCorporationCollaboration;
